module.exports = "<highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptionsdos\" style=\"height: 450px;  display: block;\">\n</highcharts-chart>"